import { ImportProposalResponse } from "../contracts/ImportProposalResponse";
import { ImportProposal } from "../models/ImportProposal";

/** Maps API import proposal responses to frontend ImportProposal models */
export class ImportProposalResponseMapper {
  toImportProposal = (response: ImportProposalResponse): ImportProposal => {
    return {
      members: (response.members ?? []).map((member) => ({
        tempId: member.tempId,
        firstName: member.firstName,
        lastName: member.lastName,
        email: member.email,
        notes: member.notes,
      })),
      groups: (response.groups ?? []).map((group) => ({
        tempId: group.tempId,
        name: group.name,
        memberTempIds: group.memberTempIds ?? [],
      })),
      sessions: (response.sessions ?? []).map((session) => ({
        tempId: session.tempId,
        title: session.title,
        weekdays: session.weekdays ?? [],
        timeLocal: session.timeLocal,
        durationMinutes: session.durationMinutes,
        memberTempIds: session.memberTempIds ?? [],
        groupTempIds: session.groupTempIds ?? [],
      })),
      warnings: response.warnings ?? [],
    };
  };
}
